import React from 'react'
import { StyleSheet, View } from 'react-native'

import * as d10 from '@/router/(root)/daily10/d10Module'

import { D10Background as Background } from "@/components/Mini/Background"
import { D10Header as Header } from "@/components/Mini/Header"
import { D10LogCard as LogCard } from "@/components/Mini/HistoryCard"


export const Daily10LogScreen = () => {

  const handleClose = d10.useHandleClose()

  return (
    <Background>
      <Header title="Your Stats" handler={handleClose} />
        <View style={styles.body}>
          <LogCard />
        </View>
      </Background>
  )
}

const styles = StyleSheet.create({
  fill: { flex: 1 },
  body: { flex: 1 }
})
